FormKo = App.loadClass "grower::viewmodels/nitrogen/Form"
ValidationEngine = App.loadClass "core::ValidationEngine"

class exports.Layer_Nitrogen_Dialog extends DialogHandler

    init: () ->
        @layoutUrl  = 'backend/grower/layers/nitrogen/dialog'
        @classes    = 'large_dialog'
        @createDialog()

        @validator = new ValidationEngine()


    getPostData: () ->
        data = "id=" + @loadLayoutPostOptions.id + "&json=" + ko.toJSON @formKO
        return data


    afterLoadLayout: (selector, response) ->
        @openDialog()

        writer = @dialog.find('.message_writer')
        writer.message_writer(response.status?.type, response.status?.msg)

        @formKO = new FormKo this, response.data, @validator
        #ko.cleanNode @dialog
        ko.applyBindings @formKO, @dialog[0]
